//import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign"
import { CampaignConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel"
import IimmpactService from "../../service/IimmpactService"

export default function (states) {
    const loadCampaignDetail = function () {
        let builder = new CampaignConfigBuilder()
        builder.setCampaignId(states.query.campaignId)
        return new Promise((resolve, reject) => {
            // console.log(states.query.token)
            IimmpactService.apiGetCampaignDetail(builder.create(), states.query.token,states.query.apiPrefix,states.blobWebLanding).subscribe({
                next: (res) => {
                    states.campaign = res
                    resolve(res)
                },
                error: (err) => {
                    states.campaign = null
                    reject(err)
                }
            });
        })
    }

    return {
        loadCampaignDetail
    }
}
